import '@learnforge/demo-kit/styles.css';
import '@learnforge/demo-kit/shell.css';
import './styles.css';

import { bootstrapDemoShell, getShotId } from '@learnforge/demo-kit';
import { makePrng } from '@learnforge/demo-math/numeric';
import { EXPERIMENTS, EXPERIMENT_ORDER } from './experiments';
import { i18n } from './i18n';
import type { ArithContext, ExperimentKey } from './types';

const params = new URLSearchParams(window.location.search);
const seedParam = params.get('seed');
const shotId = getShotId();
const seed = seedParam ? Number(seedParam) : shotId !== null ? 12345 : Date.now() >>> 0;

bootstrapDemoShell({
  slug: 'arithmetic',
  i18n,
  experiments: EXPERIMENTS,
  order: EXPERIMENT_ORDER,
  eyebrowKey: 'app.eyebrow',
  selectorAriaLabelKey: 'app.experiment-selector',
  helpLineKeys: ['app.tagline'],
  shotToExperiment: (id) =>
    (EXPERIMENT_ORDER as readonly string[]).includes(id) ? (id as ExperimentKey) : null,
  extendContext: (base): ArithContext => ({
    ...base,
    prng: makePrng(seed),
  }),
});
